module.exports = __webpack_public_path__ + "img/icon-close.156feb01.svg";